module.exports = __webpack_public_path__ + "static/media/BigJohnPRO-Regular.fd7733a1.woff";